enum UiFlags {
    NO_DATA_EXCHANGE_ENCRYPTION = 'DO_NOT_ENCRYPT_DATA_EXCHANGE',
    NO_ID_TOKEN_ENCRYPTION = 'DO_NOT_ENCRYPT_ID_TOKEN'
}

export default UiFlags;